import { Close, Expand, ExpandMore, FilterList, SearchOutlined, Token } from '@mui/icons-material'
import { AccordionDetails, Accordion, AccordionSummary, capitalize, CircularProgress, Divider, IconButton, InputAdornment, TextField } from '@mui/material'
import { useSnackbar } from 'notistack'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import PageContainer from '../components/PageContainer';
//import Accordion from '../components/common/Accordion';
import { getList, getPublicResources, getToken } from '../redux/api/system'
import { dataTags, partners, searchCategories, searchResults } from '../util'

const Help = ({ user }) => {
    const [ userData, setUserData ] = useState({});
    const [ fetching, setFetching ] = useState(false)
    const { enqueueSnackbar } = useSnackbar();

    const faqData = [
        {
            title: "What type of data can I share on the portal?",
            details: " Government data public information collected by government agencies like demographics, economic data, and environmental indicators. Organizational data anonymized data from businesses and non-profits related to operations, customer behavior, and social impact."
        },
        {
            title: "How do I know if my data is suitable for sharing?",
            details: "Licensing and usage rights: Choose appropriate licenses and specify how users can access and utilize your data."
        },
        {
            title: "What are the benefits of sharing my data?",
            details: "Increase transparency and accountability: Foster open access to information. Improve decision-making: Enable data-driven policies and practices."
        },
        {
            title: "How can I ensure my data remains secure after sharing?",
            details: "Access control: Define who can access your data and under what conditions. Encryption and anonymization: Protect sensitive inf"
        },
        {
            title: "Can I track how my data is being used?",
            details: "Some portals offer usage statistics and visualizations to see how your data is being accessed and applied."
        },
        {
            title: "What are the legal implications of sharing data?",
            details: "Consult legal professionals to understand data privacy laws and regulations applicable to your data."
        },
        {
            title: "Who can access my data once I share it?",
            details: "Access may vary depending on the portal and your preferences"
        }
    ]
    
   

    useEffect(() => {
        setUserData(user)
    }, [user])
    
    return (
        <PageContainer processing={fetching}>
            <section className="inner-banner parallax-section">
                <div className='overlay' style={{ padding: '10rem 0 12rem' }}>
                    <div className="container mt-3 mb-3">
                        <div className="row">
                            <div className="col-md-12 col-sm-12">
                                <h3 className="wow bounceIn" data-wow-delay="0.9s">HELP</h3>
                                <h1 className="wow fadeInUp text-uppercase conference mb-05 mt-05" data-wow-delay="1.6s">User Guide</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            
            <section className="p-3 mb-3 video-section" style={{ background: "#f6f9fe" }}>
                <div className="container pb-3">
                    <h3>Video Tutorial</h3>
                    <p className='pb-3'>Sample brief guide to the purpose of the portal</p>
                    <iframe width="950" height="534" src="https://www.youtube.com/embed/YILUwWyubBM" title="Sharing Data... The Easy Way" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                </div>
            </section>

            <section className='p-3 faq-section'>
                <div className='container'>
                    <h3 className='pb-2'>FAQs</h3>
                    <div className="faq-container">
                        {
                            faqData.map((next, index) => (
                                <Accordion >
                                <AccordionSummary expandIcon={<ExpandMore  />}>
                                    <p>
                                        {next.title}
                                    </p>
                                </AccordionSummary>
                                <AccordionDetails>
                                    {next.details}
                                </AccordionDetails>
                            </Accordion>
                            ))
                        }
                    </div>
                </div>
            </section>

        </PageContainer>

    )
}

export default connect(({ user }) => ({ user }))(Help)